import { render, staticRenderFns } from "./NavigableLink.vue?vue&type=template&id=35ed47ae&"
import script from "./NavigableLink.vue?vue&type=script&lang=js&"
export * from "./NavigableLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports